import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { ToastService } from "../../services/toast.service";
import { BusinessFunctionService } from "../../services/businessfunction.service";
import { IAppStore } from "../../iappstore";
import { Store } from "@ngrx/store";
import { IUserCountryTask } from "../../interfaces/iusercountrytask";
import { Features } from "../../enums/features";
import { FeatureToggleDirective } from "../../directives/featuretoggle.directive";
import { FromNowPipe } from "../../pipes/fromnow.pipe";
import { HeaderComponent } from "../header/header.component";

/**
 * Home component
 */
@Component({
    selector: "home",
    standalone: true,
    imports: [CommonModule, RouterModule, FeatureToggleDirective, FromNowPipe, HeaderComponent],
    templateUrl: "./home.component.html",
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class HomeComponent implements OnInit {
    lastValidatedDate: Date;
    defaultDate: Date = new Date(1, 1, 1);
    businessFunctionName: string;
    userCountryTasks: IUserCountryTask[];
    features = Features;

    /**
     * Check if lastValidatedDate is valid (not the default date)
     */
    get hasValidLastValidatedDate(): boolean {
        if (!this.lastValidatedDate) return false;
        const lastDate = new Date(this.lastValidatedDate);
        return lastDate.getFullYear() > this.defaultDate.getFullYear();
    }

    /**
     * Get formatted last validated date string to avoid timezone transformation issues
     */
    get formattedLastValidatedDate(): string {
        if (!this.lastValidatedDate) return '';
        const date = new Date(this.lastValidatedDate);
        const months = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'];
        return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    }

    constructor(private toastService: ToastService,
        private businessFunctionService: BusinessFunctionService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private store: Store<IAppStore>) {
    }

    /**
     * on initailse of home component.
     * here it initailse the home page contents and load the data to display.
     */
    ngOnInit(): void {
        let businessFunctionDisplayName:string = null;
        this.store.select(e => e.user.selectedBusinessFunction)
            .subscribe(e => businessFunctionDisplayName = e.displayName);
        this.lastValidatedDate = this.activatedRoute.snapshot.data["lastValidatedDate"];
        this.userCountryTasks = this.activatedRoute.snapshot.data["userCountryTasks"];
        this.businessFunctionName = businessFunctionDisplayName;
    }

    /**
     * Validates that the content on the site is up to date when the button
     * is clicked
     */
    onValidateContentClick(): void {
        this.businessFunctionService.updateValidationDate().subscribe({
            next: (h) => {
                this.lastValidatedDate = h.lastUpdatedDate;
                this.toastService.success("Last validated date has been updated");
            },
            error: (err) => {
                this.toastService.error("Failed to update validation date");
            }
        });
    }

    /**
     * Task has been clicked to be viewed by user
     * @param task
     */
    onUserCountryTaskClicked(task: IUserCountryTask): void {
        this.router.navigate([`/countries/${task.countryCode}`]);
    }
}


